import { Role } from '@customerio/hydra-permissions/roles';

export const USER_ROLE_ADMIN = Role.Admin;
export const USER_ROLE_MANAGER = Role.Manager;
export const USER_ROLE_AUTHOR = Role.Author;
export const USER_ROLE_AUTHOR_REDACT = Role.AuthorRedacted;
export const USER_ROLE_VIEWER = Role.Viewer;
export const USER_ROLE_VIEWER_REDACT = Role.ViewerRedacted;

export type UserRoleType =
  | Role.Admin
  | Role.Manager
  | Role.Author
  | Role.AuthorRedacted
  | Role.Viewer
  | Role.ViewerRedacted;

export const USER_ROLES_REDACT_SUFFIX = '-redact-on';

export const USER_ROLES: readonly UserRoleType[] = [
  USER_ROLE_ADMIN,
  USER_ROLE_MANAGER,
  USER_ROLE_AUTHOR,
  USER_ROLE_AUTHOR_REDACT,
  USER_ROLE_VIEWER,
  USER_ROLE_VIEWER_REDACT,
];

export const USER_ROLES_LABELS = {
  [USER_ROLE_ADMIN]: 'Admin',
  [USER_ROLE_MANAGER]: 'Manager',
  [USER_ROLE_AUTHOR]: 'Author',
  [USER_ROLE_AUTHOR_REDACT]: 'Author',
  [USER_ROLE_VIEWER]: 'Viewer',
  [USER_ROLE_VIEWER_REDACT]: 'Viewer',
};

export const USER_ROLES_REDACT_MAP: Record<UserRoleType, UserRoleType> = {
  [USER_ROLE_ADMIN]: USER_ROLE_ADMIN,
  [USER_ROLE_MANAGER]: USER_ROLE_MANAGER,
  [USER_ROLE_AUTHOR]: USER_ROLE_AUTHOR_REDACT,
  [USER_ROLE_AUTHOR_REDACT]: USER_ROLE_AUTHOR,
  [USER_ROLE_VIEWER]: USER_ROLE_VIEWER_REDACT,
  [USER_ROLE_VIEWER_REDACT]: USER_ROLE_VIEWER,
};
